import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Secure(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.22 1c2.756 0 5 2.243 5 5l-.001 1.636h.495c1.654 0 3 1.346 3 3v9.234c0 1.655-1.346 3-3 3H6c-1.654 0-3-1.345-3-3v-9.234c0-1.654 1.346-3 3-3h.692V6c0-2.757 2.243-5 5-5h.527zm5.494 8.636H6c-.551 0-1 .448-1 1v9.234c0 .552.449 1 1 1h11.714c.55 0 1-.448 1-1v-9.234c0-.552-.45-1-1-1zM12.22 3h-.527c-1.655 0-3 1.346-3 3l-.001 1.636h6.527V6c0-1.654-1.345-3-3-3zm-.363 8.713a2 2 0 011 3.731v2.29a1 1 0 11-2 0v-2.29a2 2 0 011-3.731z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoSecure = React.memo(Secure);
export default MemoSecure;